export const tableHeader = [
    'Sno',
    'Assigned Date',
    'Course',
    'Subject',
    'Chapter',
    'Topic',
    'Status',
    'Completed Date',
    'Action',
]

export const Lessonstatus = [
    {
        id: '01',
        name: 'completed'
    },
    {
        id: '02',
        name: 'Not completed'
    }
]